import React from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledLabel = styled.label`
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'font-size')}, clamp(14px, 2vw, 16px));
    color: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'text-color')}, ${props => props.theme.colors.primary});
    font-family: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'font-family')}, inherit);
    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'font-weight')}, 500);
    line-height: 120%;
    display: flex;
    align-items: center;
    gap: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'gap')}, clamp(8px, 1vw, 15px));

    &:disabled,
    &.${GLOBAL_STYLE_CONFIG.splitByPrefix("disabled")} {
        pointer-events: none;
        opacity: 0.5;
    }

    input {
        -webkit-appearance: none; /* отключает стандартный стиль */
        -moz-appearance: none;
        appearance: none;
        background-color: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'bg-color')}, transparent); /* любой цвет */
        border-width: 1px;
        border-style: solid;
        border-color: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'border-color')}, ${({theme}) => theme.colors.dark});
            // border: 1px solid ${({theme}) => theme.colors.dark}; /* любой цвет */
        border-radius: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'border-radius')}, 2px);

        &:checked {
            background-color: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'checked-bg-color')}, ${({theme}) => theme.colors.primaryHover}); /* любой цвет */
            border-color: var(${GLOBAL_STYLE_CONFIG.variable('checkbox', 'checked-border-color')}, ${({theme}) => theme.colors.primaryHover}); /* любой цвет */
        }
    }

`


interface CheckboxFieldProps {
    label: React.ReactNode;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    name?: string;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({
                                                         label,
                                                         checked,
                                                         onChange,
                                                         disabled = false,
                                                         name
                                                     }) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.checked);
    };

    return (
        <StyledLabel
            className={`
            ${GLOBAL_STYLE_CONFIG.splitByPrefix("form-check")}
            ${disabled ? GLOBAL_STYLE_CONFIG.splitByPrefix("disabled") : ""}
            `}
            style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                userSelect: 'none'
            }}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                name={name}
                style={{width: '16px', height: '16px', flex: '0 0 16px', cursor: disabled ? 'not-allowed' : 'pointer'}}
            />
            <span>{label}</span>
        </StyledLabel>
    );
};

export default CheckboxField;
